import React from 'react';
import { BlackRectangleProps } from "../../types/interfaces/auth"
import Logo from '../../assets/logo.svg';
export const AuthContainer: React.FC<BlackRectangleProps> = ({ children }) => {
    return (
        // Страница
        <div className="w-full min-h-dvh bg-gray-100 flex justify-center items-center">
            {/*MODAL*/}
            <div>
                <div className="flex flex-row items-center justify-center mb-12">
                    <img src={Logo} alt=""/>
                </div>
                {/*CONTAINER*/}
                <div className='flex justify-center items-center p-8 min-w-[24rem] min-h-[16rem] rounded-lg bg-white text-xl font-medium'>
                    {children}
                </div>
            </div>
        </div>
    )
}
